<template>
  <div>
    <vs-tabs alignment="left" v-model="tabSelected" v-if="hasCatalogFeature">
      <vs-tab label="Introdução">
        <div>
          <vs-card>
            <div slot="header">
              <h3>
                Desperte seu Negócio com o Catálogo
              </h3>
            </div>
            <div>
              <p class="mt-5 ml-3" style="font-size: 1.2em; margin-bottom: 2rem;">
                Descubra as infinitas vantagens do nosso inovador recurso de catálogo e transforme suas vendas de maneira eficaz.
              </p>
              <p class="mt-5 ml-3" style="font-size: 1.2em; margin-bottom: 2rem;">
                Lembre-se: cada produto adicionado ao catálogo é uma nova porta para o sucesso. Nossa equipe de suporte está sempre pronta para esclarecer suas dúvidas e fornecer assistência personalizada.
              </p>
              <p class="mt-5 ml-3" style="font-size: 1.2em; margin-bottom: 2rem;">
                Não perca a oportunidade de fazer do seu catálogo a peça central do seu crescimento empresarial. Quanto mais produtos, mais visibilidade, mais vendas!
              </p>
              <p class="mt-5 ml-3" style="font-size: 1.2em;">
                Torne seu catálogo a chave mestra para o sucesso do seu negócio!
              </p>
            </div>
            <div slot="footer" style="margin-bottom: 2rem;">
              <vs-row vs-justify="flex-end">
                <vs-button type="gradient" color="success" icon="check_circle" @click="tabSelected=3">Explorar Catálogo</vs-button>
              </vs-row>
            </div>
          </vs-card>
        </div>
      </vs-tab>
      <div v-for="(instance, index) in instances" :key="index">
        <vs-tab v-if="formatNumber(instance.phone_number) === isBusiness.id && hasCatalogFeature" :label="instance.label" :disabled="!instance.active">
          <vs-card>
        <div>
          <vs-tabs ref="flowtabs" v-model="selectedTab">
            <vs-tab :label="`Coleções`">
              <vs-popup :title="`Realmente deseja apagar a coleção ${collectionSelected.name} ?`" :active.sync="popupConfirmDelete">
                <p>Os itens da coleção ficarão no seu catálogo e nas coleções em que foram adicionados.</p>
                <div style="display: flex; justify-content: flex-end;">
                  <vs-button style="margin-right: 10px;" radius color="primary" type="gradient" icon="undo" @click="popupConfirmDelete=false" />
                  <vs-button radius color="success" type="gradient" icon="check" @click.stop="deleteCollection(collectionSelected.id, instance.id)" />
                </div>
              </vs-popup>
              <div class="centerx">
                <vs-popup class="holamundo"  :title="edit === true ? 'Editar Coleção' : 'Criar Coleção'" :active.sync="popupActivo">

                  <vs-input class="inputx mb-8" style="width: 90%; margin-left: 5%;" :placeholder="edit === true ? 'Novo Nome da Coleção' : 'Nome da Coleção'" v-model="name"/>
                  <div class="con-select-example">
                    
                    <span style="margin-left: 5%; font-size: 120%"><b>Selecione os itens:</b></span>
                    <br>
                    <span style="margin-left: 5%;">
                      No momento, a versão utilizada do catalogo, não permite a repetição de 
                      <span style="margin-left: 5%;">
                        itens de outra coleção em uma nova coleção.
                      </span> 
                    </span>
                    <v-select
                      style="margin-top: 1em; width: 90%; margin-left: 5%;"
                      v-model="selectedProducts"
                      multiple
                      :options="itens"
                    />
                    <div>
                      <vs-button color="primary" style="margin-top: 5em; margin-left: 85%;" type="filled" @popupActivo=false @click="edit === true ? editCollection(instance.id) : createCollection(instance.id, name, selectedProducts)">{{ edit === true ? 'Editar' : 'Criar' }}</vs-button>
                    </div>
                  </div>
                </vs-popup>
              </div>
              <vs-button color="primary" class="mt-2" type="filled" @click="popupCreateCollection()">Criar Coleção</vs-button>


              <vs-table
                :sst="true"
                ref="table"
                @search="handleSearch"
                @sort="sortFilter"
                noDataText="Sem dados disponíveis"
                :max-items="itemsPerPage"
                search
                :data="filterCollectionbySearch(instance.id, currentPage, itemsPerPage)"
                style="width: 100%"
                v-if="collections.length !== 0"
              >
              <div
                slot="header"
                class="flex flex-wrap-reverse items-center flex-grow justify-between"
              >
              <vs-col vs-offset="2" v-tooltip="'col - 8'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8" />
              <vs-dropdown
                vs-trigger-click
                class="md:inline-flex cursor-pointer mb-4 mr-4"
              >
                <div
                    class="
                      p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
                      cursor-pointer flex items-center justify-between font-medium
                    "
                    style="transform: translateY(0.5em); height: 2.8rem"
                >
                  <span class="mr-2">
                    {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                    {{
                          collections.length - currentPage * itemsPerPage > 0
                          ? currentPage * itemsPerPage
                          : collections.length
                    }} of {{ queriedItems }}
                  </span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage=4">
                    <span>4</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage=10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage=15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage=20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              </div>

              <template slot="thead">
                  <vs-th class="text-base" sort-key="" style="display: flex; justify-content: center; align-items: center;">
                    <div>
                      IMAGEM
                    </div>
                  </vs-th>
                  <vs-th></vs-th>
                  <vs-th class="text-base" sort-key="name" style="display: flex; justify-content: center; align-items: center;">
                    <div>
                      NOME
                    </div>
                  </vs-th>
                  <vs-th></vs-th>
                  <vs-th class="text-base" sort-key="" style="display: flex; justify-content: center; align-items: center;">
                    <div>
                      AÇÕES
                    </div>
                  </vs-th>
              </template>


              <template slot-scope="{data}">
                <vs-tr :data="tr" v-for="(tr, index) in data" :key="index" ref="vsTrElement">
                  <vs-td :data="parseStringToObject(tr.products)[0].image_cdn_urls[0].value">
                      <div class="d-flex flex-row items-center justify-around">
                        <img v-if="parseStringToObject(tr.products)[0].image_cdn_urls[0].value !== undefined && parseStringToObject(tr.products)[0].image_cdn_urls[0].value !== '' && parseStringToObject(tr.products)[0].image_cdn_urls[0].value != null" :src="parseStringToObject(tr.products)[0].image_cdn_urls[0].value" style="width: 50px !important; height: 50px !important;">
                        <img v-else src="@/assets/images/products/product_without_photo.png" style="width: 40px !important; height: 40px !important;">
                      </div>
                  </vs-td>

                  <vs-td></vs-td>

                  <vs-td :data="tr.name">
                      <div class="d-flex flex-row items-center justify-around">
                          <p class="text-center">
                            <b>
                              {{ tr.name ? tr.name : '-' }}
                            </b>
                          </p>
                      </div>
                  </vs-td>

                  <vs-td></vs-td>

                  <vs-td :data="tr.name">
                      <div class="d-flex flex-row items-center justify-center">
                        <feather-icon
                          icon="EditIcon"
                          svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          @click.stop="popupEditCollection(tr)"
                        />

                        <feather-icon
                          icon="TrashIcon"
                          svgClasses="w-5 h-5 hover:text-danger stroke-current"
                          class="ml-2"
                          @click.stop="confirmDeleteCollection(tr, instance.id)"
                        />
                      </div>
                  </vs-td>

                  <template class="expand-user" slot="expand">
                    <vs-table
                      :sst="true"
                      ref="table"
                      @search="handleSearchItem"
                      @sort="handleSort"
                      noDataText="Sem dados disponíveis"
                      :max-items="itemsPerPage"
                      :data="parseStringToObject(tr.products)"
                      style="width: 100%; margin-left: 2em; margin: 3em;"
                    >

                      <template slot="thead">
                        <vs-th class="text-base" sort-key="image_cdn_urls" style="display: flex; justify-content: center; align-items: center;">
                            <span>
                              STATUS
                            </span>
                          </vs-th>
                          <vs-th></vs-th>
                          <vs-th class="text-base" sort-key="image_cdn_urls" style="display: flex; justify-content: center; align-items: center;">
                            <span>
                              IMAGEM
                            </span>
                          </vs-th>
                          <vs-th></vs-th>
                          <vs-th class="text-base" sort-key="name" style="display: flex; justify-content: center; align-items: center;">
                            <div>
                              NOME
                            </div>
                          </vs-th>
                          <vs-th></vs-th>
                          <vs-th class="text-base" sort-key="bar_code" style="display: flex; justify-content: center; align-items: center;">
                            <div>
                              DESCRIÇÃO
                            </div>
                          </vs-th>
                          <vs-th></vs-th>
                          <vs-th class="text-base" sort-key="bar_code" style="display: flex; justify-content: center; align-items: center;">
                            <div>
                              LINK
                            </div>
                          </vs-th>
                          <vs-th></vs-th>
                          <vs-th class="text-base" sort-key="bar_code" style="display: flex; justify-content: center; align-items: center;">
                            <div>
                              CÓDIGO
                            </div>
                          </vs-th>
                          <vs-th></vs-th>
                          <vs-th class="text-base" sort-key="price" style="display: flex; justify-content: center; align-items: center;">
                            <div>
                              PREÇO
                            </div>
                          </vs-th>
                      </template>


                      <template slot-scope="{data}">
                        <vs-tr :data="trItem" v-for="(trItem, index) in data" :key="index" ref="vsTrElement">

                          <vs-td :data="trItem.capability_to_review_status.value">
                            <div class="d-flex flex-row items-center justify-around">
                                    <vx-tooltip v-if="trItem.capability_to_review_status[0].value === 'NO_REVIEW'" text="Este item está em análise. Ou seja, não está sendo exibido no seu perfil. Caso ele seja aprovado, seus clientes poderão vê-lo na sua coleção e no seu perfil." style="color: orange;">
                                      <feather-icon
                                        icon="ClockIcon"
                                        svgClasses="w-5 h-5 mt-5 hover:text-success stroke-current"
                                      />
                                    </vx-tooltip>

                                    <vx-tooltip v-else-if="trItem.capability_to_review_status[0].value === 'APPROVED'" text="A análise do item foi aprovada." style="color: green; margin-bottom: 0.8em;">
                                      <feather-icon
                                        icon="CheckCircleIcon"
                                        svgClasses="w-5 h-5 mt-5 hover:text-success stroke-current"
                                      />
                                    </vx-tooltip>

                                    <vx-tooltip v-else text="A análise do item não foi aprovada." style="color: red;">
                                      <feather-icon
                                        icon="XCircleIcon"
                                        svgClasses="w-5 h-5 mt-5 mb-5 hover:text-danger stroke-current"
                                      />
                                    </vx-tooltip>
                              </div>
                          </vs-td>

                          <vs-td></vs-td>

                          <vs-td :data="trItem.image_cdn_urls[0].value">
                              <div class="d-flex flex-row items-center justify-around">
                                <img v-if="trItem.image_cdn_urls[0].value !== undefined && trItem.image_cdn_urls[0].value !== '' && trItem.image_cdn_urls[0].value != null" :src="trItem.image_cdn_urls[0].value" style="width: 50px !important; height: 50px !important;">
                                <img v-else src="@/assets/images/products/product_without_photo.png" style="width: 40px !important; height: 40px !important;">
                              </div>
                          </vs-td>

                          <vs-td></vs-td>


                          <vs-td :data="trItem.name">
                              <div class="d-flex flex-row items-center justify-around">
                                  <p class="text-center">
                                    <b>
                                      {{ trItem.name ? trItem.name : '-' }}
                                    </b>
                                  </p>
                              </div>
                          </vs-td>

                          <vs-td></vs-td>

                          <vs-td :data="trItem.description">
                              <div class="d-flex flex-row items-center justify-around">
                                  <p class="text-center">
                                      {{ trItem.description  ? trItem.description : '-' }}
                                  </p>
                              </div>
                          </vs-td>

                          <vs-td></vs-td>

                          <vs-td :data="trItem.url">
                              <div class="d-flex flex-row items-center justify-around">
                                  <p class="text-center">
                                      {{ trItem.url ? trItem.url : '-' }}
                                  </p>
                              </div>
                          </vs-td>

                          <vs-td></vs-td>

                          <vs-td :data="trItem.retailer_id">
                              <div class="d-flex flex-row items-center justify-around">
                                  <p class="text-center">
                                      <b>
                                        <em>
                                            {{ trItem.retailer_id ? trItem.retailer_id : '-' }}
                                        </em>
                                      </b>
                                  </p>
                              </div>
                          </vs-td>

                          <vs-td></vs-td>

                          <vs-td :data="trItem.price">
                            <p class="product-price font-medium truncate text-center">
                              <b>
                                {{returnCashReal(trItem.price, trItem.currency)}}
                              </b>
                            </p>
                          </vs-td>

                        </vs-tr>
                      </template>

                    </vs-table>
                  </template>
                </vs-tr>
              </template>

            </vs-table>
            <vs-row class="mt-3" v-if="collections.length !== 0">
              <vs-col vs-offset="11" v-tooltip="'col - 1'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
                <vs-pagination
                  :max="7"
                  :total="totalPages"
                  v-model="currentPage"
                />
              </vs-col>
            </vs-row>

            </vs-tab>
            <vs-col v-if="collections.length == 0" style="margin: 11%; width: 80%;" type="flex" vs-justify="center" vs-align="center" vs-w="8" class="mt-10 mb-10">
              <vs-card>
                <div slot="header">
                  <h3 style="text-align: center;">
                    Você ainda não tem coleções cadastrado no Catálogo!
                  </h3>
                </div>
                <div>
                  <p class="mt-5 ml-3">
                    Esperamos que você esteja aproveitando a sua experiência aqui na nossa plataforma! Percebemos que você ainda não adicionou nenhuma coleção ao seu catálogo.
                    Não se preocupe, estamos aqui para ajudar! Criar uma coleção é simples e rápido. Basta seguir esses passos:
                  </p>
                  <ul style="margin-left: 5%; margin-top: 2em;">
                    <li>1. Se você tiver coleções criados no aplicativo <b>WhatsApp Business</b> é só recarregar a página.</li>
                    <li style="margin-top: 0.5em;">2. Caso não tenha, sem problemas, clique em <b>Criar Coleção</b>.</li>
                    <li style="margin-top: 0.5em;">3. Preencha os campos com as informações da sua coleção.</li>
                    <li style="margin-top: 0.5em;">4. Clique em <b>Criar</b>.</li>
                  </ul>
                  <p class="mt-5 ml-3">
                    Lembre-se de que quanto mais produtos você tiver no seu catálogo, mais oportunidades de venda terá. Se tiver alguma dúvida ou precisar de assistência, nossa equipe de suporte está à disposição para ajudar.
                  </p>
                  <p class="mt-5 ml-3">
                    Estamos ansiosos para ver os seus produtos no catálogo e ajudá-lo a ter sucesso em nossa plataforma. Fique à vontade para criar seus produtos a qualquer momento!
                  </p>
                </div>
                <div slot="footer">
                  <vs-row vs-justify="flex-end">
                    <vs-button type="gradient" color="danger" icon="favorite"></vs-button>
                  </vs-row>
                </div>
              </vs-card>
            </vs-col>
          </vs-tabs>
        </div>
      </vs-card>
        </vs-tab>
      </div>
    </vs-tabs>



  </div>
</template>

<script>
  import Vue from '@/main';
  import catalog from '@/http/requests/catalog/index.js'
  import moduleInstance   from '@/store/instance/moduleInstance';
  import { hasFeature }   from "@/utils";
  import 'flatpickr/dist/flatpickr.css'
  import flatPickr               from 'vue-flatpickr-component'
  import { VTree, VSelectTree }  from 'vue-tree-halower'
  import vSelect                 from 'vue-select'


  export default {
    name: 'collections-catalog',
    data() {
      return {
        collections: [],
        products: [],
        tabSelected: 0,
        currentPage: 1,
        search: '',
        itemsPerPage: 4,
        popupActivo:false,
        itens: [],
        sortName: '',
        orderBy: '',
        name: '',
        edit: false,
        isBusiness: [],
        selectedProducts:[],
        oldSelectedProducts:[],
        collectionId: null,
        instances: [],
        popupConfirmDelete: false,
        collectionSelected: [],
        collectionByPage: null,
        hasCatalogFeature: false,
        existBusiness: false,
        instanceId: null,
      }
    },
    components: {
        flatPickr,
        vSelect,
        VTree,
        VSelectTree
    },
    computed: {
      totalPages() {
          return this.search !== '' ? Math.ceil(this.collectionByPage / this.itemsPerPage) : Math.ceil(this.collections.length / this.itemsPerPage)
      },
      queriedItems() {
        return this.products.length
      },
      uploadApiUrl() {
          return localStorage.getItem('baseUrl') + '/api/file/upload'
      },
    },
    watch: {

      tabSelected() {
        this.search = ''
      }
    },
    methods: {
      getCollections(instanceId) {
        let collections = catalog.getCollections(instanceId);
        collections.then((response) => {
          let collection = response.data.data.getCollections;
          if (collection.length > 0) {
            this.collections = collection;
          }
          this.collections.forEach((collection) => {
            this.products.push(JSON.parse(collection.products))
          })
        }).catch((error) => {
          console.log(error);
        })
      },
      returnCashReal(value, currency) {
        const real = value / 1000;
        return real.toLocaleString('pt-BR', { style: 'currency', currency: currency })
      },
      async handleSearch(searchQuery) {
        this.search = searchQuery
        this.currentPage = 1
      },
      parseStringToObject(value) {
        try {
          let parseJson = JSON.parse(value);
          return parseJson;
        } catch (error) {
          console.error('Erro ao fazer o parsing da string:', error);
        }
      },
      lengthTextName(text) {
        if (text.length <= 120) {
          return text;
        } else {
          return text.slice(0, 120) + "...";
        }
      },
      filterCollectionbySearch(instanceId, page, itemsPerPage) {
        const offset = page * itemsPerPage - (itemsPerPage - 0);

        let collections = this.collections.filter( collection =>
          collection.instance_id === instanceId &&
          collection.name.toLowerCase().includes(this.search.toLowerCase())
        );

        let collectionsBySearch = collections;
        collections = collections.slice(offset, offset + itemsPerPage);

        this.collectionByPage = collectionsBySearch.length;

        this.filterOrderBy(collections);

        return collections;
      },
      filterOrderBy(collections) {
        if (this.orderBy === 'asc') {
          collections.sort((a, b) => a[this.sortName].localeCompare(b[this.sortName]));
        } else if (this.orderBy === 'desc') {
          collections.sort((a, b) => b[this.sortName].localeCompare(a[this.sortName]));
        } else {
          collections
        }
      },
      popupCreateCollection() {
        this.selectedProducts = [];
        this.name = '';
        this.edit = false;
        this.popupActivo = true;
        this.getItens();
      },
      async sortFilter(sortName) {
        if (this.sortName === sortName) {
          if (this.orderBy === 'asc') {
            this.sortName = sortName
            this.orderBy = 'desc'
          } else if (this.orderBy === 'desc') {
            this.sortName = ''
            this.orderBy = ''
          }
        }
        else {
          this.orderBy = 'asc'
          this.sortName = sortName
        }
        this.getItens();
      },
      popupEditCollection(data) {
        let product = JSON.parse(data.products)
        this.oldSelectedProducts = [];
        this.selectedProducts = [];
        this.collectionId = data.collection_id;
        product.forEach(product => {
          this.selectedProducts.push({id: product.id, label: product.name})
          this.oldSelectedProducts.push(product.id)
        })
        this.edit = true;
        this.name = data.name;
        this.popupActivo = true;
        this.getItens();
      },
      editCollection(instance_id) {
        let removedItems = this.oldSelectedProducts.filter(item => !this.selectedProducts.includes(item));
        let addedItems = this.selectedProducts.filter(item => !this.oldSelectedProducts.includes(item));
        let selectedItems = { collectionName: this.name, productsToAdd: addedItems, productsToRemove: removedItems}
        try {
          let requestEdit = JSON.stringify(selectedItems);
          catalog.editCollections(instance_id, this.collectionId, requestEdit);
          this.$vs.notify({
            color: 'warning',
            title: 'Solicitação de Edição de Coleção!',
            text: 'Recebemos sua solicitação para editar uma coleção. Iremos processá-la e notificaremos você assim que estiver concluída.'
          })
          this.popupActivo = false;
        } catch (error) {
          console.log(error);
          this.$vs.notify({
            color: 'danger',
            title: 'Houve um erro ao editar a coleção. Tente Novamente!',
            text: error
          })
        }
      },
      formatNumber(number) {
        return '55' + number.replace(/[^0-9]/g, "") + '@c.us'
      },
      createCollection(instanceId, name, products) {
        let selectedItens = [];
        
        if (products.length > 0) {
          products.forEach(product => {
            selectedItens.push(product.id.toString())
          })
        } else {
          this.$vs.notify({
            color: 'warning',
            title: 'Nenhum item selecionado!',
            text: 'Selecione pelo menos um item para criar uma coleção!'
          })
        }

        try {
          catalog.createCollections(instanceId, name, JSON.stringify(selectedItens));
          this.$vs.notify({
            color: 'warning',
            title: 'Solicitação de Criação de Coleção!',
            text: 'Recebemos sua solicitação para criar uma coleção. Iremos processá-la e notificaremos você assim que estiver concluída.'
          })
        } catch (error) {
          console.log(error);
          this.$vs.notify({
            color: 'danger',
            title: 'Houve um erro ao criar a coleção!',
            text: error
          })
        }
        this.popupActivo = false;
      },
      confirmDeleteCollection(collection, instanceId) {
        this.popupConfirmDelete = true;
        let data = {
          id: collection.collection_id,
          name: collection.name,
          products: JSON.parse(collection.products),
          collection_id: collection.id,
          instance_id: instanceId
        };
        this.collectionSelected = data;
      },
      deleteCollection (collectionId, instanceId) {
        try {
          catalog.deleteCollections(instanceId, collectionId)
          this.$vs.notify({
            color: 'warning',
            title: 'Solicitação de Deleção de Coleção!',
            text: 'Recebemos sua solicitação para apagar uma coleção. Iremos processá-la e notificaremos você assim que estiver concluída.'
          })
        } catch (error) {
          console.log(error)
          this.$vs.notify({
            color: 'danger',
            title: 'Houve um erro ao apagar a coleção!',
            text: error
          })
        }
        this.popupConfirmDelete = false;
      },
      getItens() {
        let itens = catalog.fetch();
        
        this.itens = [];

        itens.then((response) => {
          response.data.data.customerProducts.forEach((item, index) => {
            if (this.itens.includes(item.product_id) || this.itens.includes(item.name)) {
              return;
            }
            this.itens.push({label: item.name, id: item.product_id})
          })
        })
      },
    },
    created() {
      Vue.$events.off('UpdateCollection')
      Vue.$events.on('UpdateCollection', (event) => {
        this.getItens();

        let response = event.response;
        var patternMessage = /{"msg":"{[^{}]+}"/;
        let match = response.match(patternMessage);
        let message = match[0];
        let messageCorriged = message.slice(0, message.length - 1);
        let formattedStr = messageCorriged.replace(/\\/g, '').replace(/"msg":"/, '"msg":') + '}';
        let data = JSON.parse(formattedStr);
        if (data.msg.code !== 200) {
          this.$vs.notify({
            color: 'danger',
            title: 'Houve um erro ao atualizar a coleção!',
            text: 'Erro: ' + data.msg.text
          })
        } else {
          this.$vs.notify({
            color: 'success',
            title: 'Coleção Atualizada com Sucesso!',
            text: 'Sua coleção foi atualizada com sucesso.'
          })
        }
      });
      Vue.$events.off('GetCollections')
      Vue.$events.on('GetCollections', (event) => {
        catalog.fetch();
        this.getCollections(this.instanceId);
      });
      Vue.$events.off('DeleteCollection')
      Vue.$events.on('DeleteCollection', (event) => {
        this.getItens();
        catalog.fetch();
        this.$vs.notify({
          color: 'success',
          title: 'Coleção Apagada com Sucesso!',
          text: 'Sua coleção foi apagada com sucesso da plataforma.'
        })
      });
      Vue.$events.off('NotifyVerification')
      Vue.$events.on('NotifyVerification', (event) => {
        if (event.verification.categories) {
          this.isBusiness = event.verification
          this.existBusiness = true;
          this.$vs.loading.close('#app > .con-vs-loading')
          this.$vs.notify({
            color: 'success',
            title: 'Instâncias Business Encontrada!',
          })
        } else if (!event.verification.categories && this.existBusiness === false) {
          this.$vs.loading.close('#app > .con-vs-loading')
          this.$vs.notify({
            color: 'danger',
            title: 'Instâncias Business Não Encontrada!',
            text: 'Verifique se suas conexões estão ativas e tente novamente.',
          })
        } 
      });
      Vue.$events.off('CreateCollections')
      Vue.$events.on('CreateCollections', (event) => {
        this.getItens();
        this.$vs.notify({
          color: 'success',
          title: 'Coleção Criada com Sucesso!',
          text: 'Sua coleção foi criada com sucesso na plataforma.'
        })
      });
    },
    beforeRouteLeave(to, from, next) {
      if (this.popupActivo) {
        this.popupActivo = false;
        setTimeout( () => {
          next();
        }, 2);
      }
      else if (this.popupConfirmDelete) {
        this.popupConfirmDelete = false;
        setTimeout( () => {
          next();
        }, 2);
      } else {
        next();
      }
    },
    async mounted() {
      this.getItens();

      if (!moduleInstance.isRegistered) {
        this.$store.registerModule('instance', moduleInstance)
        moduleInstance.isRegistered = true
      }

      this.hasCatalogFeature = await hasFeature('catalog');

      if (this.hasCatalogFeature) {
        this.$vs.loading({
          type: 'radius',
          container: '#app',
          text: 'Em busca da excelência empresarial! Estamos otimizando instâncias business para melhor atendê-lo. Aguarde um momento, estamos quase lá.',
          clickEffect: true,
          background: '#B3DEFF'
        });

        setTimeout(() => {
          this.$vs.loading.close('#app > .con-vs-loading');
          if (this.existBusiness === false) {
            this.$vs.loading.close('#app > .con-vs-loading')
            this.$vs.notify({
              color: 'warning',
              title: 'Instâncias Business Não Encontrada!',
              text: 'Não foram encontradas instâncias Business. Estamos realizando uma nova verificação. Por favor, aguarde.',
            })
          }
        }, 8000);

        this.$store.dispatch('instance/fetch').then(() => {
          let getInstances = this.$store.state.instance.instances;
          
          let actives = [];

          getInstances.forEach((instance) => {
            let data = {
              id: instance.id,
              phone_number: instance.phone_number,
              label: instance.name,
              active: instance.activated
            }
            
            this.instanceId = instance.id;

            if (instance.activated) {
              this.getCollections(instance.id);
              catalog.verifyBusiness(instance.id);
            }

            this.instances.push(data)

            this.instances.forEach(instance => {
              if (!actives.some(active => active.id === instance.id)) {
                actives.push({ id: instance.id, active: instance.active });
              }
            });
          })

          const existsActive = actives.some(active => active.active === true);

          if (!existsActive && this.existBusiness === false) {
            this.$vs.loading.close('#app > .con-vs-loading')
            this.$vs.notify({
              color: 'danger',
              title: 'Instâncias Business Não Encontrada!',
              text: 'Verifique se suas conexões estão ativas e tente novamente.',
            })
          }
        })
      }

    },
  }
</script>
